import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
// import { all_routes } from "../../../Router/all_routes";
import { Spin } from "antd";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_GET_IS_MANAGER,
} from "../../Pereco/RollCall/RollCallConfig/RollCallConfig";

import footerLogo1 from "./full logo- white.avif";

const bottomStripItems = [
  { icon: "ti ti-link", label: "Real-Time Tracking" },
  { icon: "ti ti-settings", label: "Automated Payroll" },
  { icon: "ti ti-report", label: "Detailed Reports" },
  { icon: "ti ti-shield-check", label: "Secure & Reliable" },
];

const extractYoutubeVideoId = (url = "") => {
  if (!url) return "";

  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.searchParams.get("v")) {
      return parsedUrl.searchParams.get("v");
    }

    const pathSegments = parsedUrl.pathname.split("/").filter(Boolean);
    return pathSegments[pathSegments.length - 1] || "";
  } catch (error) {
    return "";
  }
};

const buildYoutubeEmbedUrl = (url = "") => {
  if (!url) return "";

  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.pathname.includes("/embed/videoseries")) {
      const playlistId = parsedUrl.searchParams.get("list");
      if (!playlistId) return url;

      return `https://www.youtube.com/embed/videoseries?list=${playlistId}&autoplay=1&mute=1&loop=1&controls=1&rel=0&modestbranding=1`;
    }

    const videoId = extractYoutubeVideoId(url);
    if (!videoId) return url;

    return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=1&rel=0&modestbranding=1`;
  } catch (error) {
    return url;
  }
};

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [Username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setloading] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const navigate = useNavigate();
  // const route = all_routes;
  const [featureCards, setFeatureCards] = useState([]);
  const [dataloading, setdataloading] = useState(false);
  const [featureCarouselSlides, setFeatureCarouselSlides] = useState([]);
  const [phoneSection, setPhoneSection] = useState({});
  const [activePhoneView, setActivePhoneView] = useState(0);

  const phoneViews = ["youtube", "linkedin", "instagram"];
  const activePhoneViewName = phoneViews[activePhoneView];

  useEffect(() => {
    const interval = setInterval(() => {
      setActivePhoneView((prev) => (prev + 1) % phoneViews.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setdataloading(true);
      try {
        const res = await axios.get(
          `${ROLL_CALL_API_BASE_URL}landing/ess/content`,
        );
        const data = res.data;

        setFeatureCards(data.cards || []);
        setFeatureCarouselSlides(data.carousel || []);
        setPhoneSection(data.phoneSection || {});
      } catch (error) {
        console.error("Error fetching content:", error);
      } finally {
        setdataloading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!featureCarouselSlides.length) return;

    const intervalId = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % featureCarouselSlides.length);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [featureCarouselSlides]);

  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [activePhoneViewName, phoneSection.instagram?.embedUrl]);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setloading(true);
    try {
      const response = await axios.post(
        `${ROLL_CALL_API_BASE_URL}ess/user/login`,
        {
          username: Username,
          password: password,
        },
      );

      const { ResultData } = response.data;
      const { Token, SuperId } = ResultData;

      if (Token && SuperId) {
        sessionStorage.setItem("authToken", Token);
        sessionStorage.setItem("userData", JSON.stringify(ResultData));
        sessionStorage.setItem("superId", SuperId);

        const managerResponse = await axios.get(
          `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_IS_MANAGER}?regid=${ResultData?.RegId}`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );

        const { ResultData: managerData } = managerResponse.data;

        const isManager = managerData?.[0]?.IsManager || false;
        sessionStorage.setItem("isManager", isManager.toString());
        // const parsedData = JSON.parse(ResultData);
        navigate(`/${ResultData.DefaultPath}`);
      } else {
        alert("Access denied.");
      }
    } catch (error) {
      alert("Login failed. Please check your credentials.");
      console.error("Login error:", error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth < 768) {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }
    };

    handleScroll();
  }, []);

  const loginCard = (
    <div className="rollcall-auth-card rollcall-auth-card--showcase mt-2">
      <h1>Sign In to your Account</h1>
      <p></p>

      <form onSubmit={handleLogin}>
        <div className="rollcall-form-group pb-1">
          <div className="rollcall-input">
            <i className="ti ti-user" />
            <input
              type="text"
              placeholder="Username"
              value={Username}
              onChange={(e) => setUserName(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="rollcall-form-group pb-1">
          <div className="rollcall-input">
            <i className="ti ti-lock" />
            <input
              type={isPasswordVisible ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <i
              className={`rollcall-password-toggle ti ${
                isPasswordVisible ? "ti-eye" : "ti-eye-off"
              }`}
              onClick={togglePasswordVisibility}
            />
          </div>
        </div>

        <button type="submit" className="rollcall-login-btn" disabled={loading}>
          {loading ? (
            <span className="spinner-border spinner-border-sm" role="status" />
          ) : (
            "Sign In"
          )}
        </button>
      </form>

      <div className="rollcall-contact-number">
        {/* <span> Copyright Â© 2025 Pereco</span> */}
      </div>
    </div>
  );

  return (
    <>
      <style>
        {`
          .rollcall-signin-page,
          .rollcall-signin-page * {
            box-sizing: border-box;
          }

        .rollcall-signin-page {
  width: 100%;
  min-height: 100dvh;   /* allow growth */
  padding: 10px;
  background:
    radial-gradient(circle at top left, rgba(65, 113, 200, 0.14), transparent 28%),
    radial-gradient(circle at right center, rgba(105, 176, 255, 0.18), transparent 24%),
    linear-gradient(180deg, #eef2fa 0%, #f8faff 100%);
  
  display: flex;
  align-items: center;
  justify-content: center;

  overflow-x: hidden;   /* only hide horizontal */
}
          .rollcall-signin-shell {
            width: min(1300px, calc(100vw - 20px));
            max-width: 100%;
            min-height: 550px;      /* base height */
  height: auto;   
            max-height: calc(100dvh - 20px);
            border-radius: 28px;
            overflow: hidden;
            display: grid;
            grid-template-columns: minmax(350px, 360px) minmax(0, 1fr);
            background: rgba(255, 255, 255, 0.64);
            box-shadow: 0 28px 80px rgba(45, 77, 140, 0.18);
            backdrop-filter: blur(10px);
          }

          .rollcall-auth-pane {
            position: relative;
            height: 100%;
            padding: 18px 20px;
            background:
              rgba(18, 58, 120, 0.38),
              url("assets/img/emile-perron-xrVDYZRGdw4-unsplash.jpg") center/cover;
            color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;
          }

          .rollcall-auth-pane::before {
            content: "";
            position: absolute;
            inset: 0;
            background:
              radial-gradient(circle at 20% 90%, rgba(121, 190, 255, 0.26), transparent 30%),
              radial-gradient(circle at 85% 18%, rgba(255, 255, 255, 0.12), transparent 18%);
            pointer-events: none;
          }

          .rollcall-auth-content,
          .rollcall-auth-brand {
            position: relative;
            z-index: 1;
          }

          .rollcall-auth-content {
            max-width: 320px;
            margin: 0 auto;
            width: 100%;
            display: flex;
            justify-content: center;
          }

          .rollcall-auth-content > .rollcall-auth-card {
            display: none;
          }

          .rollcall-auth-brand img {
            width: min(176px, 100%);
            display: block;
            margin: 0 auto;
          }

          .rollcall-auth-card {
            margin-top: 16px;
            padding: 16px 15px 15px;
            border-radius: 20px 20px 70px 20px;
            background: linear-gradient(180deg, rgba(5, 35, 80, 0.88), rgba(11, 58, 125, 0.92));
            border: 1px solid rgba(255, 255, 255, 0.14);
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
            backdrop-filter: blur(12px);
          }

          .rollcall-auth-card--showcase {
            width: 100%;
            max-width: 360px;
            margin: 0 auto;
          }

          .rollcall-auth-card h1 {
            margin: 0 0 8px;
            font-size: 18px;
            line-height: 1.2;
            font-weight: 800;
            color: #ffffff;
          }

          .rollcall-auth-card p {
            margin: 0 0 14px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.8);
          }

          .rollcall-form-group {
            margin-bottom: 10px;
          }

          .rollcall-input {
            display: flex;
            align-items: center;
            min-height: 38px;
            border: 1px solid rgba(255, 255, 255, 0.16);
            border-radius: 12px;
            background: rgba(104, 151, 224, 0.2);
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
          }

          .rollcall-input:focus-within {
            border-color: rgba(152, 213, 255, 0.72);
            box-shadow: 0 0 0 3px rgba(102, 190, 255, 0.16);
          }

          .rollcall-input i {
            padding-left: 14px;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.82);
          }

          .rollcall-input input {
            width: 100%;
            border: 0;
            outline: 0;
            background: transparent;
            color: #ffff;
            font-size: 13px;
            padding: 9px 10px 9px 8px;
          }

          .rollcall-input input::placeholder {
            color: rgba(255, 255, 255, 0.75);
          }

          .rollcall-password-toggle {
            padding-right: 14px;
            cursor: pointer;
            font-size: 14px;
          }

          .rollcall-form-row {
            margin: 8px 0 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            color: rgba(255, 255, 255, 0.88);
            font-size: 13px;
          }

          .rollcall-checkbox {
            display: inline-flex;
            align-items: center;
            gap: 10px;
          }

          .rollcall-checkbox input {
            width: 18px;
            height: 18px;
            accent-color: #68adff;
          }

          .rollcall-forgot {
            color: rgba(255, 255, 255, 0.88);
            text-decoration: none;
          }

          .rollcall-forgot:hover {
            color: #ffffff;
          }

          .rollcall-login-btn {
            width: 100%;
            border: 0;
            border-radius: 12px;
            padding: 11px 16px;
            background: linear-gradient(180deg, #4ea5ff 0%, #1d74f6 100%);
            color: #ffffff;
            font-size: 14px;
            font-weight: 800;
            letter-spacing: 0.08em;
            box-shadow: 0 16px 32px rgba(30, 116, 246, 0.3);
          }

          .rollcall-login-btn:disabled {
            opacity: 0.7;
          }

          .rollcall-social-row {
            margin: 12px 0 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
          }

          .rollcall-social-icon {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 16px;
            text-decoration: none;
            box-shadow: 0 12px 24px rgba(3, 24, 64, 0.18);
          }

          .rollcall-social-icon.google {
            background: #ffffff;
            color: #ef4444;
          }

          .rollcall-social-icon.facebook {
            background: #1d74f6;
          }
              .rollcall-social-icon.instagram {
            background: #c97b9c;
          }

          .rollcall-social-icon.linkedin {
            background: #c7400b;
          }

          .rollcall-social-icon.twitter {
            background: #1da1f2;
          }

          .rollcall-beta-btn {
            width: 100%;
            min-height: 38px;
            border: 1px solid rgba(255, 255, 255, 0.24);
            border-radius: 12px;
            background: rgba(10, 28, 61, 0.22);
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            text-decoration: none;
            font-weight: 500;
            font-size: 12px;
          }

          .rollcall-contact-number1 {
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.92);
          }
                .rollcall-contact-number {
            margin-top: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.92);
          }

          .rollcall-showcase-pane {
            position: relative;
            height: 100%;
            padding: 26px 30px 24px;
            background:
              linear-gradient(135deg, rgba(255, 255, 255, 0.88), rgba(239, 246, 255, 0.66)),
              url("assets/img/backgroundimg2.jpg") center/cover;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 12px;
            overflow: hidden;
          }

          .rollcall-showcase-pane::before {
            content: "";
            position: absolute;
            inset: 0;
            background:
              linear-gradient(180deg, rgba(255, 255, 255, 0.28), rgba(255, 255, 255, 0.1)),
              radial-gradient(circle at 15% 25%, rgba(131, 189, 255, 0.18), transparent 20%),
              radial-gradient(circle at 88% 15%, rgba(151, 196, 255, 0.22), transparent 24%);
            pointer-events: none;
          }

          .rollcall-showcase-content {
            position: relative;
            z-index: 1;
            width: 100%;
            padding: 0 6px;
          }

          .rollcall-topbar {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex-wrap: wrap;
            gap: 12px;
            margin-bottom: 18px;
            color: #17335c;
            font-size: 14px;
          }

          .rollcall-topbar-item {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            color: #17335c;
          }

          .rollcall-divider {
            width: 1px;
            height: 20px;
            background: rgba(23, 51, 92, 0.16);
          }

          .rollcall-topbar-social {
            display: inline-flex;
            gap: 10px;
          }

          .rollcall-topbar-social a {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            color: #ffffff;
          }

          .rollcall-topbar-social .facebook {
            background: #2563eb;
          }

          .rollcall-topbar-social .linkedin {
            background: #c7400b;
          }
                  .rollcall-topbar-social .instagram {
            background: #c97b9c;
          }

          .rollcall-topbar-social .twitter {
            background: #1da1f2;
          }

          .rollcall-showcase-title {
            margin: 0 0 10px;
            color: #0f274b;
            font-size: clamp(24px, 2.1vw, 38px);
            line-height: 1.12;
            font-weight: 800;
            max-width: 620px;
          }

          .rollcall-showcase-subtitle {
            margin: 0 0 18px;
            color: #263a5c;
            font-size: 15px;
            max-width: 620px;
          }

          .rollcall-feature-layout {
            display: grid;
            grid-template-columns: minmax(0, 1fr) 190px;
            gap: 16px;
            align-items: start;
            margin-bottom: 12px;
          }

          .rollcall-feature-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 12px;
          }

          .rollcall-feature-card {
            min-height: 132px;
            border-radius: 16px;
            padding: 12px 14px;
            background: rgba(255, 255, 255, 0.86);
            border: 1px solid rgba(208, 223, 247, 0.8);
            box-shadow: 0 18px 34px rgba(74, 109, 173, 0.12);
            display: grid;
            grid-template-columns: 86px minmax(0, 1fr);
            gap: 10px;
            align-items: stretch;
            width: 100%;
          }

          .rollcall-feature-card.is-small {
            grid-template-columns: 80px minmax(0, 1fr);
          }

          .rollcall-feature-card.is-carousel {
            min-height: 146px;
          }

          .rollcall-feature-card.is-carousel .rollcall-feature-image img {
            max-height: 82px;
          }

          .rollcall-feature-body {
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 10px;
          }

          .rollcall-feature-copy {
            min-width: 0;
          }

          .rollcall-feature-actions {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            width: 100%;
          }

          .rollcall-phone-ad {
            position: relative;
            width: 225px;
            height: 390px;
            padding: 12px;
            border-radius: 38px;
            background: linear-gradient(180deg, #091a34 0%, #0b234b 100%);
            border: 2px solid rgba(255, 255, 255, 0.9);
            box-shadow: 0 28px 50px rgba(16, 43, 88, 0.26);
            margin-top: -74px;
          }

          .rollcall-phone-ad--auth {
            margin-top: 16px;
          }

          .rollcall-feature-layout > .rollcall-phone-ad {
            display: none;
          }

          .rollcall-phone-ad::before {
            content: "";
            position: absolute;
            top: 10px;
            left: 50%;
            transform: translateX(-50%);
            width: 84px;
            height: 9px;
            border-radius: 999px;
            background: rgba(255, 255, 255, 0.26);
          }

          .rollcall-phone-screen {
            height: 100%;
            border-radius: 30px;
            padding: 0;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            color: #fff;
            background:
              linear-gradient(180deg, rgba(173, 186, 201, 0.96) 0%, rgba(83, 121, 177, 0.98) 100%),
              url("assets/img/backgroundimg2.jpg") center/cover;
          }

          .rollcall-phone-screen--content {
            padding: 14px 10px 10px;
            justify-content: space-between;
          }

          .rollcall-phone-screen--youtube,
          .rollcall-phone-screen--linkedin {
            background: #1b2026;
          }

          .rollcall-phone-stage {
            position: relative;
            width: 100%;
            height: 100%;
            min-height: 0;
          }

          .rollcall-phone-copy h4 {
            margin: 0 0 8px;
            font-size: 18px;
            line-height: 1.05;
            font-weight: 800;
          }

          .rollcall-phone-copy p {
            margin: 0;
            font-size: 11px;
            line-height: 1.45;
            color: rgba(255, 255, 255, 0.88);
          }

          .rollcall-phone-list {
            display: grid;
            gap: 6px;
            flex: 1;
            min-height: 0;
            overflow: hidden;
          }

          .rollcall-phone-list span {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 7px 9px;
            border-radius: 12px;
            background: rgba(9, 34, 77, 0.24);
            font-size: 10px;
            font-weight: 500;
          }

          .rollcall-phone-youtube {
            gap: 8px;
            height: 100%;
            width: 100%;
          }

          .rollcall-phone-youtube-player {
            height: 100%;
            overflow: hidden;
            background: #071120;
          }

          .rollcall-phone-youtube-player iframe {
            width: 100%;
            height: 100%;
            border: 0;
            display: block;
          }

          .rollcall-phone-linkedin {
            height: 100%;
            width: 100%;
          }

          .rollcall-feature-image {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 100%;
          }

          .rollcall-feature-image img {
            width: 100%;
            max-height: 72px;
            object-fit: contain;
            filter: drop-shadow(0 12px 16px rgba(33, 61, 117, 0.12));
          }

          .rollcall-feature-text h3 {
            margin: 0 0 8px;
            color: #0f274b;
            font-size: clamp(15px, 1vw, 19px);
            line-height: 1.15;
            font-weight: 800;
          }

          .rollcall-feature-card.is-small .rollcall-feature-text h3 {
            font-size: clamp(14px, 0.92vw, 17px);
          }

          .rollcall-feature-text p {
            margin: 0;
            color: #2d466f;
            font-size: 12px;
            line-height: 1.35;
          }

          .rollcall-learn-btn {
            border: 0;
            border-radius: 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: blue;
            font-size: 15px;
            font-weight: 700;
            letter-spacing: 0.05em;
            text-decoration: none;
            margin-left: auto;
          }

          .rollcall-card-dots {
            display: flex;
            gap: 8px;
            margin-top: 0;
          }

          .rollcall-card-dots span {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: rgba(34, 116, 211, 0.22);
          }

          .rollcall-card-dots span.active {
            background: #2d86f6;
          }

          .rollcall-highlight-strip,
          .rollcall-bottom-strip {
            display: grid;
            align-items: center;
            gap: 12px;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.64);
            border: 1px solid rgba(208, 223, 247, 0.86);
            box-shadow: 0 16px 30px rgba(74, 109, 173, 0.08);
          }

          .rollcall-highlight-strip {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            padding: 14px 18px;
          }

          .rollcall-bottom-strip {
            grid-template-columns: repeat(4, minmax(0, 1fr));
            margin-top: 0;
            padding: 12px 18px;
          }

          .rollcall-strip-item {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            color: #17335c;
            font-size: 13px;
            text-align: center;
          }

          .rollcall-strip-item i {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: rgba(38, 117, 246, 0.12);
            color: #1f5ec9;
            font-size: 15px;
          }

          @media (max-width: 1199px) {
            .rollcall-signin-shell {
              grid-template-columns: minmax(300px, 340px) minmax(0, 1fr);
            }

            .rollcall-showcase-pane {
              padding: 22px 22px 18px;
            }

            .rollcall-feature-layout {
              grid-template-columns: 1fr;
            }

            .rollcall-feature-grid {
              grid-template-columns: 1fr;
            }

            .rollcall-phone-ad {
              width: min(205px, 100%);
              height: 292px;
              margin-top: 0;
              margin: 0 auto;
            }

            .rollcall-auth-card--showcase {
              max-width: 100%;
            }
          }

          @media (max-width: 991px) {
            .rollcall-signin-page {
              height: auto;
              min-height: 100dvh;
              padding: 12px;
              overflow: visible;
            }

            .rollcall-signin-shell {
              width: min(100%, calc(100vw - 24px));
              height: auto;
              max-height: none;
              grid-template-columns: 1fr;
            }

            .rollcall-auth-pane,
            .rollcall-showcase-pane {
              height: auto;
              overflow: visible;
              padding: 20px;
            }

            .rollcall-highlight-strip {
              grid-template-columns: 1fr;
            }

            .rollcall-bottom-strip {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
            .signin-footer-content {
              grid-template-columns: 1fr;
              gap: 20px;
            }
          }

          @media (max-width: 767px) {
            .rollcall-signin-page {
              padding: 10px;
            }

            .rollcall-signin-shell {
              width: min(100%, calc(100vw - 20px));
              height: auto;
              border-radius: 22px;
            }

            .rollcall-auth-card h1 {
              font-size: 22px;
            }

            .rollcall-showcase-title {
              font-size: 28px;
            }

            .rollcall-topbar {
              justify-content: flex-start;
              margin-bottom: 24px;
            }

            .rollcall-divider {
              display: none;
            }

            .rollcall-feature-card,
            .rollcall-feature-card.is-small {
              grid-template-columns: 1fr;
              text-align: center;
            }

            .rollcall-feature-actions {
              justify-content: center;
            }

            .rollcall-phone-copy h4 {
              font-size: 20px;
            }

            .rollcall-feature-image img {
              max-width: 200px;
            }

            .rollcall-topbar-social {
              flex-wrap: wrap;
            }

            .rollcall-card-dots,
            .rollcall-strip-item {
              justify-content: center;
            }

            .rollcall-bottom-strip {
              grid-template-columns: 1fr;
            }

            .rollcall-form-row {
              flex-direction: column;
              align-items: flex-start;
            }
          }


          
.signin-footer {
  margin-top: 10px;
}

.signin-footer-main {
  padding: 40px 0 18px;
  background: linear-gradient(135deg, #bc1615, #e44c0a);
}

.signin-footer-grid {
  align-items: flex-start;
  row-gap: 24px;
}

.signin-footer-brand {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.signin-footer-logo {
  max-width: 240px;
}

.signin-footer-social {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.signin-footer-social a,
.signin-footer-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.signin-footer-social a {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
  text-decoration: none;
}

.signin-footer-address {
  display: inline-flex;
  align-items: flex-start;
  gap: 12px;
  color: #fff;
  text-decoration: none;
  line-height: 1.5;
}

.signin-footer-content {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 24px;
}

.signin-footer-title {
  margin: 0 0 12px;
  font-size: 1.1rem;
  font-weight: 700;
}

.signin-footer-contact {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.signin-footer-line {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  line-height: 1.5;
}

.signin-footer-email-list,
.signin-footer-links {
  margin: 0;
  padding: 0;
  list-style: none;
}

.signin-footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.signin-footer-links a {
  color: #fff;
  text-decoration: none;
}

.signin-footer-divider {
  margin: 24px 0 12px;
}

.signin-footer-copy {
  text-align: center;
  font-size: 0.85rem;
}

        `}
      </style>
      <div className="rollcall-signin-page">
        <div className="rollcall-signin-shell">
          <aside className="rollcall-auth-pane">
            <div className="rollcall-auth-brand">
              <Link to="/home">
                <img src="assets/img/logo.png" alt="RollCall Attendance" />
              </Link>
            </div>

            <div className="rollcall-auth-content">
              <div className="rollcall-phone-ad rollcall-phone-ad--auth">
                <div
                  className={`rollcall-phone-screen ${
                    activePhoneViewName === "youtube"
                      ? "rollcall-phone-screen--youtube"
                      : "rollcall-phone-screen--linkedin"
                  }`}
                  style={{ position: "relative", minHeight: "200px" }}
                >
                  {dataloading ? (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(255,255,255,0.6)",
                        zIndex: 10,
                      }}
                    >
                      <div className="text-center">
                        <Spin size="large" />
                        <p className="mt-2">Loading...</p>
                      </div>
                    </div>
                  ) : (
                    <>
                      {activePhoneViewName === "youtube" &&
                        phoneSection.youtube?.enabled &&
                        phoneSection.youtube?.embedUrl && (
                          <div className="rollcall-phone-stage rollcall-phone-youtube">
                            <div className="rollcall-phone-youtube-player">
                              <iframe
                                src={buildYoutubeEmbedUrl(
                                  phoneSection.youtube.embedUrl,
                                )}
                                title={
                                  phoneSection.youtube.title ||
                                  "Pereco India YouTube"
                                }
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              />
                            </div>
                          </div>
                        )}

                      {activePhoneViewName === "linkedin" &&
                        phoneSection.linkedin?.enabled &&
                        phoneSection.linkedin?.embedUrl && (
                          <div className="rollcall-phone-stage rollcall-phone-linkedin">
                            <div className="rollcall-phone-youtube-player">
                              <iframe
                                src={phoneSection.linkedin.embedUrl}
                                title={
                                  phoneSection.linkedin.title || "LinkedIn Post"
                                }
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              />
                            </div>
                          </div>
                        )}

                      {activePhoneViewName === "instagram" &&
                        phoneSection.instagram?.enabled &&
                        phoneSection.instagram?.embedUrl && (
                          <div className="rollcall-phone-stage rollcall-phone-linkedin">
                            <div style={{ width: "100%", margin: "0 auto" }}>
                              <blockquote
                                className="instagram-media"
                                data-instgrm-permalink={
                                  phoneSection.instagram.embedUrl
                                }
                                data-instgrm-version="14"
                                style={{ width: "100%" }}
                              ></blockquote>
                            </div>
                          </div>
                        )}
                    </>
                  )}
                </div>

                <div className="rollcall-contact-number1">
                  <span className="text-dark">Copyright © 2026 Pereco</span>
                </div>
              </div>

              <div className="rollcall-auth-card">
                <h1>Welcome to RollCall Attendance</h1>
                <p>Sign in to your account</p>

                <form onSubmit={handleLogin}>
                  <div className="rollcall-form-group">
                    <div className="rollcall-input">
                      <i className="ti ti-user" />
                      <input
                        type="text"
                        placeholder="Username"
                        value={Username}
                        onChange={(e) => setUserName(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="rollcall-form-group">
                    <div className="rollcall-input">
                      <i className="ti ti-lock" />
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <i
                        className={`rollcall-password-toggle ti ${
                          isPasswordVisible ? "ti-eye" : "ti-eye-off"
                        }`}
                        onClick={togglePasswordVisibility}
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="rollcall-login-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      />
                    ) : (
                      "Sign In"
                    )}
                  </button>
                </form>

                <div className="rollcall-contact-number">
                  <span> Copyright © 2026 Pereco</span>
                </div>
              </div>
            </div>
          </aside>

          <section
            className="rollcall-showcase-pane"
            style={{ position: "relative", minHeight: "300px" }}
          >
            {dataloading ? (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(255,255,255,0.7)",
                  zIndex: 10,
                }}
              >
                <div className="text-center">
                  <Spin size="large" />
                  <p className="mt-2">Loading features...</p>
                </div>
              </div>
            ) : (
              <>
                <div className="rollcall-showcase-content">
                  <div className="rollcall-topbar">
                    <div className="rollcall-topbar-item">
                      <i className="ti ti-brand-whatsapp" />
                      <span>WhatsApp</span>
                    </div>
                    <div className="rollcall-divider" />
                    <div className="rollcall-topbar-item">
                      <i className="ti ti-phone-call" />
                      <span>+91-8297230010</span>
                    </div>
                    <div className="rollcall-divider" />
                    <div className="rollcall-topbar-social">
                      <a
                        href="https://www.youtube.com/@perecoindia"
                        className="linkedin"
                        aria-label="Location"
                      >
                        <i className="ti ti-brand-youtube-filled" />
                      </a>
                      <a
                        href="https://www.facebook.com/Perecoindia/"
                        className="facebook"
                        aria-label="Facebook"
                      >
                        <i className="ti ti-brand-facebook-filled" />
                      </a>
                      <a
                        href="https://www.instagram.com/pereco_india/"
                        className="instagram"
                        aria-label="Verified"
                      >
                        <i className="ti ti-brand-instagram" />
                      </a>
                      <a
                        href="https://x.com/PerecoIndia"
                        className="twitter"
                        aria-label="Twitter"
                      >
                        <i className="ti ti-brand-twitter-filled" />
                      </a>
                    </div>
                  </div>

                  <h2 className="rollcall-showcase-title">
                    Explore Our Products & Solutions
                  </h2>
                  <p className="rollcall-showcase-subtitle">
                    Streamline your business with our time attendance and
                    payroll management solutions.
                  </p>

                  <div className="rollcall-feature-layout">
                    <div className="rollcall-feature-grid">
                      {featureCards.map((item, index) => {
                        const isCarousel = index === 0;

                        const currentItem = isCarousel
                          ? featureCarouselSlides[activeSlide] || {}
                          : item;

                        return (
                          <article
                            key={index}
                            className={`rollcall-feature-card ${
                              isCarousel ? "is-carousel" : ""
                            } ${item?.large ? "" : "is-small"}`}
                          >
                            <div className="rollcall-feature-image">
                              <img
                                src={currentItem.image}
                                alt={currentItem.title}
                                loading="lazy"
                              />
                            </div>

                            <div className="rollcall-feature-body">
                              <div className="rollcall-feature-text rollcall-feature-copy">
                                <h3>{currentItem.title}</h3>
                                <p>{currentItem.description}</p>
                              </div>

                              <div className="rollcall-feature-actions">
                                {isCarousel &&
                                  featureCarouselSlides.length > 0 && (
                                    <div className="rollcall-card-dots">
                                      {featureCarouselSlides.map(
                                        (_, slideIndex) => (
                                          <span
                                            key={slideIndex}
                                            className={
                                              slideIndex === activeSlide
                                                ? "active"
                                                : ""
                                            }
                                          />
                                        ),
                                      )}
                                    </div>
                                  )}

                                <Link
                                  to={currentItem?.link || "#"}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="rollcall-learn-btn"
                                >
                                  <i className="ti ti-arrow-right" />
                                </Link>
                              </div>
                            </div>
                          </article>
                        );
                      })}
                    </div>

                    {loginCard}
                  </div>

                  <div className="rollcall-bottom-strip">
                    {bottomStripItems.map((item) => (
                      <div key={item?.label} className="rollcall-strip-item">
                        <i className={item?.icon} />
                        <span>{item?.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </section>
        </div>
      </div>
      <div className="signin-footer">
        <footer className="bg-dark text-white signin-footer-main">
          <div className="container">
            <div className="row signin-footer-grid">
              <div className="col-lg-5 col-md-6 text-start overview-text">
                <div className="signin-footer-brand">
                  <img
                    src={footerLogo1}
                    alt=""
                    className="img-fluid signin-footer-logo"
                  />

                  <div className="signin-footer-social">
                    <a
                      href="https://www.instagram.com/pereco_india/?igsh=MXFrNXRieHozMHVicA%3D%3D#"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                    <a
                      href="https://www.facebook.com/Perecoindia/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <i className="fa-brands fa-facebook"></i>
                    </a>
                    <a
                      href="https://x.com/PerecoIndia"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/perennial-code/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <i className="fa-brands fa-linkedin"></i>
                    </a>
                    <a
                      href="https://www.youtube.com/@perecoindia"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <i className="fa-brands fa-youtube"></i>
                    </a>
                  </div>

                  <a
                    href="https://www.google.com/maps/dir//opp.+ASK+Educational+Society,+Vittal+Nagar,+Adikmet,+Hyderabad,+Telangana+500044/@17.4059614,78.4262689,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bcb99a6320e26bb:0x199d77b1f4faac56!2m2!1d78.5086707!2d17.4059783?entry=ttu"
                    className="signin-footer-address"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-solid fa-location-dot signin-footer-icon"></i>
                    <span className="text-start">
                      <span className="d-block">
                        Vidya Nagar Street Number 7,
                      </span>
                      <span className="d-block">
                        Hyderabad, Telangana, 500044
                      </span>
                    </span>
                  </a>
                </div>
              </div>
              <div className="col-lg-7 col-md-6 overview-text">
                <div className="signin-footer-content">
                  <div className="text-start overview-text">
                    <h4 className="signin-footer-title">Contact</h4>
                    <div className="signin-footer-contact small">
                      <p className="signin-footer-line">
                        <i className="fa-solid fa-phone signin-footer-icon"></i>
                        <span>+91 8297230010</span>
                      </p>
                      <div className="signin-footer-line">
                        <i className="fa-solid fa-envelope signin-footer-icon"></i>
                        <ul className="signin-footer-email-list overview-text">
                          <li>
                            <a
                              href="mailto:sales@perennialcode.in"
                              style={{ color: "white" }}
                            >
                              sales@perennialcode.in
                            </a>
                          </li>
                          <li>
                            <a
                              href="mailto:support@perennialcode.in"
                              style={{ color: "white" }}
                            >
                              support@perennialcode.in
                            </a>
                          </li>
                          <li>
                            <a
                              href="mailto:info@perennialcode.in"
                              style={{ color: "white" }}
                            >
                              info@perennialcode.in
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="text-start overview-text">
                    <h5 className="signin-footer-title">Quick Links</h5>
                    <ul className="signin-footer-links">
                      <li>
                        <a
                          href="https://www.perennialcode.in"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white text-decoration-none"
                        >
                          Home
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.perennialcode.in/aboutus"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white text-decoration-none"
                        >
                          About Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.perennialcode.in/solutions"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white text-decoration-none"
                        >
                          Solutions
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.perennialcode.in/contactus"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white text-decoration-none"
                        >
                          Contact Us
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <hr className="border-light signin-footer-divider" />

            <div className="signin-footer-copy">
              &copy; 2026 Perennial Code. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Signin;
